import { render, staticRenderFns } from "./ot-claim-runs.vue?vue&type=template&id=8ab2d48c&scoped=true&"
import script from "./ot-claim-runs.vue?vue&type=script&lang=ts&"
export * from "./ot-claim-runs.vue?vue&type=script&lang=ts&"
import style0 from "./ot-claim-runs.vue?vue&type=style&index=0&id=8ab2d48c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ab2d48c",
  null
  
)

export default component.exports